module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/logo_master.c8bdcd8d.svg";